@if (formArray && formGroupHtml) {
<div>
  <div class="d-flex flex-column">
    <div class="w-100 d-flex justify-content-end mb-3">
      <button mat-raised-button type="button" color="primary" [disabled]="!canModify()" (click)="addNewFormGroupContextBase()">
        {{ 'VOUCHER.ATP.NEW' | translate }}
      </button>
    </div>

    <app-voucher-atp-form
      [formGroupAtpHtml]="formGroupHtml"
      [canModify]="canModify()"
      (removeContextBase)="removeContextBase($event)"
    ></app-voucher-atp-form>
  </div>
</div>
}
